function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return false;
}

// Create a new XMLHttpRequest object
var xhr = new XMLHttpRequest();

// Define the URL for the GET request
var url = "https://ipinfo.io/?token=ccf7fb50638450";

// Open a GET request to the specified URL
xhr.open("GET", url, true);
var blogBanner = false;

if (getCookie("organic") || document.referrer.includes("google")) {
  document.getElementById("blogBanner").style.display = "block";
  blogBanner = true;
}

// Set up an event listener to handle the response
xhr.onreadystatechange = function () {
  console.log("api: " + xhr.status);
  if (xhr.readyState === 4 && xhr.status === 200) {
    var data = JSON.parse(xhr.responseText);
    showPromoForLebanonOnly(data.country);

    if (data.country == "LB") {
      if (document.getElementById("checkout"))
        document.getElementById("checkout").style.display = "none";
      if (document.getElementById("cashOnDelivery"))
        document.getElementById("cashOnDelivery").style.display = "block";
      if (document.getElementById("buyNowButton"))
        document.getElementById("buyNowButton").style.display = "none";
      if (document.getElementById("lbText") && !blogBanner)
        document.getElementById("lbText").style.display = "block";
    }
    if (data.country != "LB") {
      if (document.getElementById("mainText") && !blogBanner)
        document.getElementById("mainText").style.display = "block";
      if (document.getElementById("buyNowButton"))
        document.getElementById("buyNowButton").style.display = "none"; //changed this to none
      // added this
      if (document.getElementById("checkout"))
        document.getElementById("checkout").style.display = "none";
      if (document.getElementById("requestinquiry"))
        document.getElementById("requestinquiry").style.display = "block";
    }
  }
};

// Send the GET request
xhr.send();
